import script from "./ScrollTree.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollTree.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollTree.vue?vue&type=style&index=0&id=cd352110&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd352110"]])

export default __exports__